import {ReactElement} from 'react'
import {Slides} from '../../../Slides'
import {SwiperProps} from 'swiper/react'
import {getBannerSlides} from './utils'
import {Container} from './styles'
import {BannersCarouselProps} from './types'

const slidesProps: SwiperProps = {
  autoplay: {delay: 5000},
  loop: true,
  centeredSlides: true,
  autoHeight: false,
  slidesPerView: 1,
}

export function BannersCarousel({isClientEligible, company}: BannersCarouselProps): ReactElement {
  const slides = getBannerSlides({isClientEligible, company})

  const showPagination = slides.length > 1

  return (
    <Container>
      <Slides
        slides={slides}
        {...slidesProps}
        pagination={{clickable: true, enabled: showPagination}}
      />
    </Container>
  )
}
